import React from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import UI from "components/UI"
import Button from "../../../components/buttons";
import UIUtil from "../../../utils/UIUtils";

export default ContentsContainer;
function ContentsContainer(props: any) {
    const OZViewerStyle:React.CSSProperties = {
        width:"98%",
        height:"98%"
    }
    const jsondata = {"Category":[{"CategoryID": 1,"CategoryName":"음료","Description": "청량음료, 커피, 홍차, 맥주"},{"CategoryID":2,"CategoryName":"조미료","Description":"감미료, 향신료, 양념, 스프레드"}], "Product":[{"ProductID":75,"ProductName":"알파인 맥주","CategoryID":1,"QuantityPerUnit":"24 - 0.5 l bottles","UnitPrice":24000.0000,"UnitsInStock":125},{"ProductID":39,"ProductName":"OK 바닐라 셰이크","CategoryID":1,"QuantityPerUnit":"750 cc per bottle","UnitPrice":28000.0000,"UnitsInStock":69},{"ProductID":34,"ProductName":"태일 라이트 맥주","CategoryID":1,"QuantityPerUnit": "24 - 12 oz bottles","UnitPrice":34000.0000,"UnitsInStock":111},{"ProductID":65,"ProductName":"루이지애나 특산 후추","CategoryID":2,"QuantityPerUnit":"32 - 8 oz bottles","UnitPrice":21000.0000,"UnitsInStock":76},{"ProductID":61,"ProductName":"사계절 핫 소스","CategoryID":2,"QuantityPerUnit":"24 - 500 ml bottles","UnitPrice":28000.0000,"UnitsInStock":92},{"ProductID":6,"ProductName":"대양 특선 블루베리 잼","CategoryID":2,"QuantityPerUnit": "12 - 8 oz jars","UnitPrice":25000.0000,"UnitsInStock":120}]};

    const reportName = "jsonsample";

    const parmameter = {
        "connection.pcount":"2",
        "connection.args1":"jsondata="+ JSON.stringify(jsondata),
        "connection.args2":"viewerType=HTML5 Canvas Viewer",

        "information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부

        // "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
        // "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

        "pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
        "pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

        "export.format":"pdf", // 저장포맷
        "export.filename": reportName + ".pdf", // 파일명
        "export.mode":"silent", // 설정창 보여줄지 여부

        "viewer.pagedisplay":"continuous", // 페이지 표시 옵션
        "viewer.viewmode":"normal", // 보고서 보기 모드
    }

    const onClickHandler = () => {
        UIUtil.openOZReportViewerPopup({
            reportName:reportName,
            parameter:parmameter,
            onClose: () => {
                console.log("Report Viewer Close");
            },
            title:"Sample"
        })
    }

    return (
        <PageContainer session={false}>
            <LayoutAside />
            <div className="fww-con">
                <main className="fww-main">
                    <div className="fo fo-col3 mb10">
                        <Button color='pri' size="md" onClick={onClickHandler}>리포트 보기</Button>
                        {/*<UI.ReportViewer style={OZViewerStyle} parameter={parmameter} reportName={reportName} />*/}
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}